export enum RoleEnum {
  admin = <any>'admin',
  manager = <any>'manager',
  employee = <any>'employee',
}
